export const modalDataSet = {
  cy: 'modal-visible',
};
